module.exports = __webpack_public_path__ + "img/why-icon-3.6227f6d2.svg";